import { render, staticRenderFns } from "./ManageDelivery.vue?vue&type=template&id=f0cc4c60&scoped=true"
import script from "./ManageDelivery.vue?vue&type=script&lang=js"
export * from "./ManageDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cc4c60",
  null
  
)

export default component.exports